// apps/scheduler-worker/src/components/Header.tsx
import { Menu } from 'lucide-react';

interface HeaderProps {
  title: string;
  onMenuClick?: () => void;
}

export function Header({ title, onMenuClick }: HeaderProps) {
  return (
    <header className="sticky top-0 z-10 h-14 border-b bg-white px-4 flex items-center justify-between">
      <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
      {onMenuClick && (
        <button
          onClick={onMenuClick}
          className="p-2 -mr-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg"
          aria-label="Open menu"
        >
          <Menu className="h-6 w-6" />
        </button>
      )}
    </header>
  );
}
